export function wxOauth (appId, scope, state) {
  let url = 'https://open.weixin.qq.com/connect/oauth2/authorize?'
  const path = window.location.href.split('?')[0] || ''
  let search = window.location.href.split('?')[1] || ''

  search = decodeURIComponent(search)

  // 如果连接里面有state和code,先去掉
  search = search.replace(`&state=${getQueryString('state')}`, '')
  search = search.replace(`&code=${getQueryString('code')}`, '')

  const redirectUri = path + (search ? '?' + encodeURIComponent(search) : '')
  let params = {
    appid: appId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: scope || 'snsapi_userinfo',
    state: state || ''
  }

  let i
  const arr = []
  for (i in params) {
    arr.push(i + '=' + params[i])
  }

  params = arr.join('&')
  url += params + '#wechat_redirect'
  window.location.href = url
}

function getQueryString (name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  const r = decodeURIComponent(window.location.search)
    .substr(1)
    .match(reg)
  if (r != null) {
    return unescape(r[2])
  }
  return null
}
